import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'
import { ListItemIndicator } from '@root/shared/ui-kit'

export const WalletListItemSkeleton: React.FC = () => {
  return (
    <Root>
      <Indicator color="#363636" />
      <Skeleton width={10} height={10} variant="circular" />
      <ColumnLeft>
        <Skeleton width={80} height={10} />
        <Skeleton width={60} height={5} />
      </ColumnLeft>
      <ColumnRight>
        <Skeleton width={80} height={10} />
        <Skeleton width={60} height={5} />
      </ColumnRight>
      <Skeleton width={18} height={18} variant="circular" />
    </Root>
  )
}

const Root = styled.div`
  background: var(--backgroundA-3);

  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  height: 60px;

  position: relative;
  border-radius: 16px;
  padding-inline: 16px;
  overflow: hidden;
`

const ColumnLeft = styled.div`
  display: flex;
  flex-direction: column;

  gap: 4px;
  padding-inline: 10px;
`

const ColumnRight = styled(ColumnLeft)`
  align-items: flex-end;
`

const Indicator = styled(ListItemIndicator)`
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(calc((60px - 100%) / 2));
`
